<template>
  <div>
    <v-card class="mt-4">
      <v-system-bar>Card</v-system-bar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="3">
              <Markdown :value="text" />
            </v-col>
            <v-col cols="3">
              <Card>
                <CardTitle>Card Title</CardTitle>
                <CardDescription>Card Description</CardDescription>

                <CardContent>
                  <v-list>
                    <v-list-item v-for="i in 3" :key="`item-${i}`">
                      <v-list-item-content>
                        <v-list-item-title>Item {{ i }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </CardContent>
                <CardFooter>
                  <v-btn color="primary" text>Action</v-btn>
                </CardFooter>
              </Card>
            </v-col>
            <v-col cols="3">
              <Card>
                <CardTitle>Card Title</CardTitle>
                <CardDescription
                  >Card Description asdfasdf
                  <p>asdfasdf</p></CardDescription
                >
              </Card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import Card from "common/components/ui/card/Card.vue";
import CardTitle from "common/components/ui/card/CardTitle.vue";
import CardDescription from "common/components/ui/card/CardDescription.vue";
import CardContent from "common/components/ui/card/CardContent.vue";
import CardFooter from "common/components/ui/card/CardFooter.vue";

const text = `
Card mit v-system-bar und v-card-text
`;

export default defineComponent({
  components: {
    Card,
    CardTitle,
    CardDescription,
    CardContent,
    CardFooter,
  },
  name: "CardTest",
  data() {
    return {
      text,
    };
  },
  computed: {},
  watch: {},
});
</script>
